import * as React from "react"

export const SettingsFormField = props => {
    const {
        label,
        className,
        value,
        onChangeAction,
        id,
        focus,
        type,
        placeholder,
        required,
        tabIndex,
        setRef,
        preventAutoComplete,
    } = props

    const shouldAutoFocus = focus ? { autoFocus: true } : {}
    const fieldType = type || "text"
    const tabIn = tabIndex || 0
    const renderLabel = label && <label className={className}>{label}</label>

    return (
        <div className="settings-form-field-wrapper">
            {renderLabel}
            <input
                {...shouldAutoFocus}
                className="form-control"
                type={fieldType}
                value={value}
                onChange={v => {
                    onChangeAction(v.target.value, id)
                }}
                placeholder={placeholder}
                required={required}
                tabIndex={tabIn}
                ref={setRef}
                autoComplete={preventAutoComplete ? "new-password" : "on"}
            />
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/settings/settings_form_field.jsx